module.exports = "/assets/8af3de72adda21361aaecabe7921fea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KF.png
// module id = 2667
// module chunks = 0